<template>
  <div>
    <offerte-step1 v-if="currentStep === 1 && serviceForm === false" :formdata="formData"></offerte-step1>
    <offerte-step2 v-if="currentStep === 2 && serviceForm === false" :formdata="formData"></offerte-step2>
    <offerte-step3 v-if="currentStep === 3 && serviceForm === false" :formdata="formData"></offerte-step3>
    <offerte-step4 v-if="currentStep === 4 && serviceForm === false" :formdata="formData"></offerte-step4>
    <offerte-step5 v-if="currentStep === 5 && serviceForm === false" :formdata="formData"></offerte-step5>

    <service-step1 v-if="currentStep === 1 && serviceForm === true" :formdata="formData"></service-step1>
    <service-step2 v-if="currentStep === 2 && serviceForm === true" :formdata="formData"></service-step2>
    <service-step3 v-if="currentStep === 3 && serviceForm === true" :formdata="formData"></service-step3>
    <service-step4 v-if="currentStep === 4 && serviceForm === true" :formdata="formData"></service-step4>
  </div>
</template>

<script>
import OfferteStep1 from "@/components/OfferteStep1.vue";
import OfferteStep2 from "@/components/OfferteStep2.vue";
import OfferteStep3 from "@/components/OfferteStep3.vue";
import OfferteStep4 from "@/components/OfferteStep4.vue";
import OfferteStep5 from "@/components/OfferteStep5.vue";


import ServiceStep1 from "@/components/ServiceStep1.vue";
import ServiceStep2 from "@/components/ServiceStep2.vue";
import ServiceStep3 from "@/components/ServiceStep3.vue";
import ServiceStep4 from "@/components/ServiceStep4.vue";



export default {
  data() {
    return {
      currentStep:1,
      formData: {
        firstname:'',
        lastname:'',
        email:'',
        aantal_personen:'',
        phone:'',
        cellphone:'',
        company:'',
        street:'',
        housenumber:'',
        zipcode:'',
        city:'',
        country:'',
        lookingfor:'',
        movable:'',
        requirements_text:'',
        extra_notes:'',
        tradein:false,
        quantity:0,
        units:0,
        images:[],
      },
      serviceForm:false,

    }
  },
  components: {
    ServiceStep1,
    'offerte-step1' : OfferteStep1,
    'offerte-step2' : OfferteStep2,
    'offerte-step3' : OfferteStep3,
    'offerte-step4' : OfferteStep4,
    'offerte-step5' : OfferteStep5,

    'service-step1' : ServiceStep1,
    'service-step2' : ServiceStep2,
    'service-step3' : ServiceStep3,
    'service-step4' : ServiceStep4,
  },
  methods: {

  },
  mounted()
  {
    if(window.serviceForm === true)
      this.serviceForm = true

    this.emitter.on("step", step => {
      this.currentStep = step;
    });

    this.emitter.on("modelUpdated", model => {
      this.formData = model;
    });


    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get('d');
    if(myParam)
    {
      var base = atob(myParam)
      var json = JSON.parse(base)
      // this.formData.lookingfor = json.type
      this.formData.lookingfor = json.opties[0]
    }

  }

}
</script>

<style>
input.invalid, select.invalid {
  animation: shake 0.2s ease-in-out 0s 2;
  box-shadow: 0 0 4px #ff0000;
}

@keyframes shake {
  0% {
    margin-left: 0rem;
  }
  25% {
    margin-left: 0.5rem;
  }
  75% {
    margin-left: -0.5rem;
  }
  100% {
    margin-left: 0rem;
  }
}
</style>